import React, { createRef, useCallback, useState } from "react";
import PropTypes from "prop-types";
import SearchBox from "~components/organisms/search/search_input/search_input";
import SearchResultsList from "~components/organisms/search/search_instant_dropdown/components/search_instant_dropdown_results_list/search_instant_dropdown_results_list";
import useClickOutside from "~hooks/use_click_outside/use_click_outside";
import InstantSearchWrapper from "../search_provider/search_provider";
import SearchInstantDropdownWrapper from "./components/search_instant_dropdown_wrapper/search_instant_dropdown_wrapper";
import {
  searchResultWrapperStyle,
  searchWrapperStyle,
} from "./search_instant_dropdown.module.scss";

export default function ScopedSearch({ indices, searchResourcesTitle }) {
  const rootRef = createRef();
  const [queryState, setQueryState] = useState();
  const [hasFocus, setFocus] = useState(false);

  useClickOutside(rootRef, () => {
    return setFocus(false);
  });
  const handleFocus = useCallback(() => {
    return setFocus(true);
  }, []);

  return (
    <div className={searchWrapperStyle} ref={rootRef}>
      <InstantSearchWrapper callbackToUpdateQueryState={setQueryState}>
        <SearchBox
          placeholder={searchResourcesTitle}
          leadingIcon="icon_search"
          onFocus={handleFocus}
        />

        <div className={searchResultWrapperStyle}>
          <SearchInstantDropdownWrapper
            show={hasFocus && queryState && queryState.length > 0}
          >
            <SearchResultsList indices={indices} />
          </SearchInstantDropdownWrapper>
        </div>
      </InstantSearchWrapper>
    </div>
  );
}
ScopedSearch.propTypes = {
  indices: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string }))
    .isRequired,
  searchResourcesTitle: PropTypes.string,
};
ScopedSearch.defaultProps = {
  searchResourcesTitle: "Search resources",
};
